import * as React from "react";
import { memo } from "react";
const SvgAlertBackground = (props) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", width: 366, height: 57, viewBox: "0 0 366 57", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M366 9.05294L359.053 1.69619L4.371 0L0 45.4619L12.0231 57L359.053 53.7457L366 9.05294Z", fill: "currentColor" }));
const Memo = memo(SvgAlertBackground);
export default Memo;
